import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { connect } from 'react-redux';
import { selectBirdElementsState, selectLayoutState, selectMaximizeState, } from '../../store/selectors';
import { Splitter } from '@sas/nova-commons/components/Splitter';
import { Child } from '../Box/createChildren';
import { TabBar } from '@sas/nova-commons/components/TabBar';
import { Media } from '../Media';
const MaximizedLayoutBase = (props) => {
    var _a;
    const { supplementalKeys = [], supplementalVisualLabels = {}, mediaKey } = (_a = props.maximizeState) !== null && _a !== void 0 ? _a : {};
    const maximizedVisual = mediaKey ? (_jsx(Media, { id: mediaKey })) : (_jsx(Child, { id: props.id, state: props.elementState, style: {
            position: 'relative',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            overflow: 'hidden',
        } }));
    const [selectedIndex, setSelectedIndex] = useState(0);
    const selectedVisual = supplementalKeys[selectedIndex];
    if (supplementalKeys.length === 0 || !selectedVisual) {
        return maximizedVisual;
    }
    return (_jsxs(Splitter, Object.assign({ orientation: "vertical", sections: [{}, { defaultSize: '25%', collapsible: true, fullyCollapsible: true }], hideGripIcon: false, style: { height: '100%', width: '100%' } }, { children: [_jsx("div", Object.assign({ style: {
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingBottom: '0.5rem',
                    boxSizing: 'border-box',
                } }, { children: maximizedVisual })), _jsxs("div", Object.assign({ style: {
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '0.75rem 0.25rem 0.25rem 0.25rem',
                    boxSizing: 'border-box',
                } }, { children: [supplementalKeys.length > 1 ? (_jsx(TabBar, { selectedIndex: selectedIndex, onItemSelected: ({ index }) => setSelectedIndex(index), overflowMenuButtonDisplay: "onVisibleScrollbar", items: supplementalKeys.map((key) => {
                            var _a;
                            return ({
                                label: (_a = supplementalVisualLabels[key]) !== null && _a !== void 0 ? _a : key,
                            });
                        }) })) : undefined, _jsx(Child, { id: selectedVisual, state: props.elementState, style: { position: 'relative', flexGrow: 1, overflow: 'hidden' } }, selectedVisual)] }))] })));
};
export const MaximizedLayout = connect((state, props) => ({
    layoutState: selectLayoutState(state, props.id),
    maximizeState: selectMaximizeState(state, props.id),
    elementState: selectBirdElementsState(state),
}))(MaximizedLayoutBase);
